export default {
  // Currently used
  home_search_for_product: "Search for the LED alternatives of your conventional product",
  conventional_alternative: "Conventional Alternative",
  led_alternative: "LED Alternative",
  search_filters_filter: "Filter",
  alt_filters_filter: "LED Alternative Filter",
  search_submit: "Search product",
  results: "Results",
  selected_product: "Selected product",
  search_input: "Type in (part of) the product code or description",
  what_type_are_you_looking_for: "What type of product replacement are you looking for?",
  recommendations_singular: "Recommendation",
  recommendations_plural: "Recommendations",
  your_product: "Your Product",
  search_filters_reset: "Reset filters",
  results_specify: "There are more than 10 results, please further specify your search",
  energy_efficient: "Energy efficient",
  active_filters: "Active filters",
  card_action: "Catalogue",
  card_show_more: "Show more",
  card_show_less: "Show less",
  card_alternative_fit: "Philips Best Alternative",
  card_perfect_fit: "Philips Best Fit",
  no_results_found: "No results found. Please try a different search query",
  results_no_recommendations: "Stuck? Please contact your local account manager or sales representative to find a solution.",
  led_no_recommendations: "There are no LED alternatives for this product.",
  ballast_notice: "The ballast compatibility for electronic ballast (HF) needs to be checked.",
  ballast_notice_tled_link_text: "TLED compatibility list",
  ballast_notice_pl_led_link_text: "PL LED compatibility list",

  // LED facets
  search_filter_product_type: "Product type",
  lighting_type: "Type of Lamp",
  ean: "EAN",
  product_code: "Product code",
  eoc: "EOC",
  family: "Family",
  discrete_wattage: "Wattage",
  wattage: "Wattage",
  brand: "Brand",
  driver_type: "Driver Type",
  number_of_lamps: "Number of Lamps",
  length: "Length",
  color: "Color",
  base: "Base",
  local_eoc: "Local code",
  lumen: "Lumen",
  energy_saving: "Energy Saving",
  tiering: "Tiering",
  ballast_compatibility: "Ballast Compatibility",
  lifetime: "Lifetime",

  // Conventional facets
  ignitor: "Ignitor",
  height: "Height",
  width: "Width",
  mounting_hole: "Mounting Hole",
  mains_voltage: "Mains Voltage",
  thermal_protection: "Thermal Protection",
  delta_temperature: "Delta Temperature",
  energy_efficiency: "Energy Efficiency",
  losses: "Losses",
  lamp_current: "Lamp Current",
  pf_cap: "PF Cap",
}
